import React, { useEffect } from 'react';
import { getCurrentMedicationSettings } from './Async/MedicationSettingsAsync';
import { AlertBanner, AlertBannerTypes } from './Components/AlertBanner';
import { useAsync } from './Hooks/useAsync';
import { useHttpConfig } from './Shared/HttpRequestExecutor';
import styles from './DecisionSupportWarningAlert.module.css';
import { useMedicationSettings } from './Config/MedicationConfig';
export var DecisionSupportWarningAlert = function (props) {
    var httpConfig = useHttpConfig();
    var medicationSettingsAsync = useAsync({
        defaultValue: null,
        httpConfig: httpConfig,
        getApi: getCurrentMedicationSettings
    });
    var medicationSettings = useMedicationSettings();
    var decisionSupportSettings = medicationSettings.settings.decisionSupportSettings;
    var showBanner = (!decisionSupportSettings.medicationToAllergiesEnabled ||
        !decisionSupportSettings.medicationToConditionEnabled ||
        !decisionSupportSettings.medicationToMedicationEnabled ||
        !decisionSupportSettings.medicationToPregnancyEnabled) &&
        decisionSupportSettings.showDecisionSupportWarning;
    useEffect(function () {
        medicationSettingsAsync.getApi();
    }, []);
    if (!medicationSettingsAsync.data ||
        !medicationSettingsAsync.data.decisionSupportSettings.showDecisionSupportWarning)
        return null;
    return (React.createElement(React.Fragment, null, (showBanner || props.isComplementary) &&
        React.createElement(AlertBanner, { lowerHeight: true, verticalSpace: true, infoLine: React.createElement(React.Fragment, null,
                React.createElement("label", { className: styles.decisionSupportWarningTitle }, medicationSettingsAsync.data.decisionSupportSettings.decisionSupportWarningTitle),
                "\u00A0",
                medicationSettingsAsync.data.decisionSupportSettings.decisionSupportWarningDescription), promptType: AlertBannerTypes.Error, noBorder: props.noBorder, roundIcon: true })));
};
